import cn from 'classnames';

import PIC_BEAUTY_SALON from 'assets/images/makeup-brush-colorful.png';
import PIC_HAIR_SALON from 'assets/images/scissors-colorful.png';
import { useTranslation } from 'providers/GILT.provider';

import CN from './QuickSetupType.module.scss';

const OPTIONS = [
  {
    id: 1,
    titleKey: 'register.quickSetup.salonOption1Title',
    descKey: 'register.quickSetup.salonOption1Description',
    icon: PIC_HAIR_SALON,
  },
  {
    id: 2,
    titleKey: 'register.quickSetup.salonOption2Title',
    descKey: 'register.quickSetup.salonOption2Description',
    icon: PIC_BEAUTY_SALON,
  },
];

export const QuickSetupType = ({ activeSalonType, onOptionClick }) => {
  const { t } = useTranslation();

  return (
    <div data-bem="QuickSetupType" className={CN.component}>
      {OPTIONS.map(({ id, titleKey, descKey, icon }) => {
        const isActive = activeSalonType === id;

        return (
          <button key={id} data-bem={`QuickSetupType__option-${id}`} className={cn(CN.option, { [CN.active]: isActive })} onClick={() => onOptionClick(id)}>
            <div className={CN.iconCircle}>
              <img src={icon} alt="" className={CN.icon} />
            </div>
            <div className={CN.text}>
              <span className={CN.title}>{t(titleKey)}</span>
              <span className={CN.description}>{t(descKey)}</span>
            </div>
          </button>
        );
      })}
    </div>
  );
};
